import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/profile', // 推广 
  name: 'profile',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.profile',
    requiresAuth: true,
    icon: 'icon-user',
    order: 6,
  },
  children: [
    {
      path: 'setting',
      name: 'setting',
      component: () => import('@/views/user/setting/index.vue'),
      meta: {
        locale: 'menu.myInfo',
        requiresAuth: true,
        roles: ['**'],
      },
    },
    // {
    //   path: 'withdrawApply', // The midline path complies with SEO specifications
    //   name: 'withdrawApply',
    //   permission: 'profile:withdraw',
    //   component: () => import('@/views/person/withdrawApply/index.vue'),
    //   meta: {
    //     locale: 'menu.withdrawApply',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'profile:info',
    //   },
    // },
    // {
    //   path: 'myPromotion', // The midline path complies with SEO specifications
    //   name: 'myPromotion',
    //   permission: 'profile:promotion',
    //   component: () => import('@/views/person/myPromotion/index.vue'),
    //   meta: {
    //     locale: 'menu.myPromotion',
    //     requiresAuth: true,
    //     roles: ['*'],
    //     permission: 'profile:promotion',
    //   },
    // },
  ],
};

export default LIST;
